import { JobList, JobTotalMoney, WXReturnMoney, ALIReturnMoney, JobReturnMoney, GetCapitalStatistic, JobOver, DeleteJob, RefundJob, RefundErrorJob } from '@/api/job'
export default {
  state: {

  },
  actions: {
    JobList({ commit }, payload) {
      return new Promise(resolve => {
        JobList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DeleteJob({ commit }, payload) {
      return new Promise(resolve => {
        DeleteJob(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    JobTotalMoney({ commit }, payload) {
      return new Promise(resolve => {
        JobTotalMoney(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    WXReturnMoney({ commit }, payload) {
      return new Promise(resolve => {
        WXReturnMoney(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    RefundJob({ commit }, payload) {
      return new Promise(resolve => {
        RefundJob(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    ALIReturnMoney({ commit }, payload) {
      return new Promise(resolve => {
        ALIReturnMoney(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    JobReturnMoney({ commit }, payload) {
      return new Promise(resolve => {
        JobReturnMoney(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetCapitalStatistic({ commit }, payload) {
      return new Promise(resolve => {
        GetCapitalStatistic(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    JobOver({ commit }, payload) {
      return new Promise(resolve => {
        JobOver(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    RefundErrorJob({ commit }, payload) {
      return new Promise(resolve => {
        RefundErrorJob(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  getters: {

  },
  mutations: {

  }
}
